import {create} from "zustand";

export const useIsMenuModalOpen = create((set) => ({
    isMenuModalOpen: false,
    setIsMenuModalOpen: (value) => set(({isMenuModalOpen: value})),
}))
